import { render, staticRenderFns } from "./AmfTable.vue?vue&type=template&id=5c044625&scoped=true&"
import script from "./AmfTable.vue?vue&type=script&lang=js&"
export * from "./AmfTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c044625",
  null
  
)

export default component.exports